import { Frameworks } from "components/Docs/Integrate";
import * as React from 'react';
export default {
  Frameworks,
  React
};